import { InferProps } from 'prop-types';

import MDButton from 'components/MDButton';
import MDAlert from 'components/MDAlert';
import MDBadge from 'components/MDBadge';
import MDTypography from 'components/MDTypography';
import MDBox from './MDBox';

export const Button = MDButton as any;
export const Alert = MDAlert as any;
export const Badge = MDBadge as any;
export const Typography = MDTypography as any;
export const Box = MDBox as any;
